import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function AcRangeBar(props) {
    if (props.variant === 'enum') {
        return renderEnum(props);
    }
    if (props.variant === 'bipolar') {
        return renderBipolar(props);
    }
    return renderLinear(props);
}
function renderLinear(p) {
    const min = p.min ?? 0;
    const max = p.max ?? 127;
    const step = p.step ?? 1;
    const fillPct = pct(p.value, min, max);
    const style = { '--ac-range-fill': `${fillPct}%` };
    const className = p.className ? `ac-range-bar ${p.className}` : 'ac-range-bar';
    const interactive = p.onChange !== undefined;
    return (_jsxs("div", { className: className, ...rootAriaProps(p.ariaLabel, interactive), children: [renderTicks(p.startTick, p.midTick, p.endTick), _jsx("div", { className: "ac-range-bar__fill", style: style }), interactive ? (_jsx("input", { className: "ac-range-bar__input", type: "range", min: min, max: max, step: step, value: p.value, disabled: p.disabled, "aria-label": p.ariaLabel, onChange: (e) => p.onChange?.(Number(e.target.value)) })) : null] }));
}
function renderBipolar(p) {
    const center = p.center ?? 0;
    const step = p.step ?? 1;
    const span = p.max - p.min;
    if (span <= 0) {
        throw new Error(`AcRangeBar bipolar requires max > min (got min=${p.min}, max=${p.max})`);
    }
    const centerPct = ((center - p.min) / span) * 100;
    const valPct = ((p.value - p.min) / span) * 100;
    const left = Math.min(centerPct, valPct);
    const width = Math.abs(valPct - centerPct);
    const style = {
        '--ac-range-bar-l': `${left}%`,
        '--ac-range-bar-w': `${width}%`,
    };
    const baseClass = 'ac-range-bar ac-range-bar--bipolar';
    const className = p.className ? `${baseClass} ${p.className}` : baseClass;
    const interactive = p.onChange !== undefined;
    return (_jsxs("div", { className: className, ...rootAriaProps(p.ariaLabel, interactive), children: [renderTicks(p.startTick, p.midTick, p.endTick), _jsx("div", { className: "ac-range-bar__fill", style: style }), interactive ? (_jsx("input", { className: "ac-range-bar__input", type: "range", min: p.min, max: p.max, step: step, value: p.value, disabled: p.disabled, "aria-label": p.ariaLabel, onChange: (e) => p.onChange?.(Number(e.target.value)) })) : null] }));
}
function renderEnum(p) {
    if (p.count < 1) {
        throw new Error(`AcRangeBar enum requires count >= 1 (got ${p.count})`);
    }
    const baseClass = 'ac-range-bar ac-range-bar--enum';
    const className = p.className ? `${baseClass} ${p.className}` : baseClass;
    const interactive = p.onChange !== undefined;
    const pips = [];
    for (let i = 0; i < p.count; i += 1) {
        const active = i === p.activeIndex;
        const title = p.itemTitles?.[i];
        if (interactive) {
            pips.push(_jsx("button", { type: "button", className: "ac-range-bar__enum-pip", "data-active": active ? 'true' : undefined, "aria-pressed": active, "aria-label": title ?? `Option ${i + 1}`, title: title, disabled: p.disabled, onClick: () => p.onChange?.(i) }, i));
        }
        else {
            pips.push(_jsx("span", { className: "ac-range-bar__enum-pip", "data-active": active ? 'true' : undefined, title: title }, i));
        }
    }
    return (_jsx("div", { className: className, ...rootAriaProps(p.ariaLabel, interactive), children: _jsx("div", { className: "ac-range-bar__enum-track", role: interactive ? 'radiogroup' : undefined, "aria-hidden": interactive ? undefined : true, children: pips }) }));
}
function rootAriaProps(ariaLabel, interactive) {
    if (interactive) {
        // When interactive, the inner <input type="range"> (or <button> pips)
        // carries the accessible role + name. The outer wrapper is presentational.
        return {};
    }
    return { role: 'img', 'aria-label': ariaLabel };
}
function renderTicks(startTick, midTick, endTick) {
    const out = [];
    if (startTick !== undefined) {
        out.push(_jsx("span", { className: "ac-range-bar__tick ac-range-bar__tick--start", children: startTick }, "s"));
    }
    if (midTick !== undefined) {
        out.push(_jsx("span", { className: "ac-range-bar__tick ac-range-bar__tick--mid", children: midTick }, "m"));
    }
    if (endTick !== undefined) {
        out.push(_jsx("span", { className: "ac-range-bar__tick ac-range-bar__tick--end", children: endTick }, "e"));
    }
    return out;
}
function pct(value, min, max) {
    if (max <= min) {
        throw new Error(`AcRangeBar linear requires max > min (got min=${min}, max=${max})`);
    }
    const clamped = Math.min(max, Math.max(min, value));
    return ((clamped - min) / (max - min)) * 100;
}
//# sourceMappingURL=AcRangeBar.js.map